import React from 'react'
import env from './../../../../environments/environment'
import './OurProducts.component.scss'

const cdnImg = file =>
  `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fwebsite%2F${file}?alt=media`

const products = [
  {
    image: cdnImg('img.product-health.png'),
    alt: 'Woman with blonde hair, smiling, seated on white sofa, wearing a pink lace dress, looking at the viewer.',
    title: 'Health Insurance',
    description:
      'Need coverage for yourself or your family? We help you compare Marketplace health plans, understand subsidies, and enroll in coverage that works for you.',
    href: '/health-insurance',
  },
  {
    image: cdnImg('img.product-medicare.png'),
    alt: 'Elderly couple smiling at each other while sitting at a kitchen table with mugs and a bowl of cookies.',
    title: 'Medicare Insurance',
    description:
      'Simple guidance for Medicare Advantage, Medicare Supplement (Medigap), and prescription drug plans. We help you understand your options and choose coverage that fits your healthcare needs and budget.',
    href: '/medicare-insurance',
  },
  {
    image: cdnImg('img.product-life.png'),
    alt: 'Man holding baby, looking at each other, woman gazing up, smiling. Bright room with window.',
    title: 'Life Insurance',
    description:
      'Protect the people who matter most. We help you compare life insurance options designed to provide financial security and peace of mind for your loved ones.',
    href: '/life-insurance',
  },
  {
    image: cdnImg('img.product-smallbiz.png'),
    alt: 'Group of diverse business professionals standing together, looking at the camera. Woman in front has arms crossed.',
    title: 'Small Business',
    description:
      'Coverage solutions for small business owners, including group health options and employee benefits designed to support your team and your business.',
    href: '/small-business-insurance',
  },
]

const OurProducts = () => {
  return (
    <section className='our-products'>
      <h2 className='our-products__heading'>
        <span>Our Insurance Products</span>
      </h2>
      <p className='our-products__subtext'>
        <span>Compare plans, explore options, and get covered faster.</span>
      </p>

      <div className='our-products__cards'>
        {products.map(product => (
          <div key={product.title} className='our-products__card'>
            <div className='our-products__card-image'>
              <img src={product.image} alt={product.alt} width='940' height='788' />
            </div>
            <div className='our-products__card-content'>
              <h2 className='our-products__card-title'>{product.title}</h2>
              <p className='our-products__card-desc'>
                <span>{product.description}</span>
              </p>
              <a href={product.href} className='our-products__card-btn' target='_blank' rel='noopener noreferrer'>
                <span>Explore Coverage Options</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default OurProducts
